var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWanring({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8002 13C25.8002 20.0692 20.0694 25.7999 13.0002 25.7999C5.93095 25.7999 0.200195 20.0692 0.200195 13C0.200195 5.93071 5.93095 0.199951 13.0002 0.199951C20.0694 0.199951 25.8002 5.93071 25.8002 13ZM14.6002 19.4C14.6002 20.2836 13.8839 21 13.0002 21C12.1165 21 11.4002 20.2836 11.4002 19.4C11.4002 18.5163 12.1165 17.7999 13.0002 17.7999C13.8839 17.7999 14.6002 18.5163 14.6002 19.4ZM13.0002 4.99995C12.1165 4.99995 11.4002 5.7163 11.4002 6.59995V13C11.4002 13.8836 12.1165 14.6 13.0002 14.6C13.8839 14.6 14.6002 13.8836 14.6002 13V6.59995C14.6002 5.7163 13.8839 4.99995 13.0002 4.99995Z",
    fill: "#F08E0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWanring);
export default __webpack_public_path__ + "static/media/icon-wanring.0f95d6bc134ed309efdd5a0bd552cea6.svg";
export { ForwardRef as ReactComponent };